import * as React from 'react';
import lottie from 'lottie-web';
export const LottieAnimation = ({ data, url, loop = false, }) => {
    const ref = React.useRef(null);
    React.useEffect(() => {
        if (data && ref.current) {
            lottie.loadAnimation({
                animationData: data,
                container: ref.current,
                renderer: 'svg',
                loop,
            });
        }
        if (url && ref.current) {
            lottie.loadAnimation({
                path: url,
                container: ref.current,
                renderer: 'svg',
                loop,
            });
        }
        return () => lottie.destroy();
    }, [data, url, loop]);
    return React.createElement("div", { "data-cy-label": "lottie-animation", ref: ref });
};
//# sourceMappingURL=LottieAnimation.js.map